import { render, staticRenderFns } from "./ModalSuporteEditarHospitalSla.vue?vue&type=template&id=cddc29ca"
import script from "./ModalSuporteEditarHospitalSla.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteEditarHospitalSla.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports